import styled from "styled-components";
import cat404 from "../assets/404cat.jpg";
import { Link } from "react-router-dom";

export function Error404() {
  return (
    <Container>
      <Content>
        <Image src={cat404} alt="Error 404" />
        <Message>Oups ! On dirait que cette page n'existe pas.</Message>
        <BackButton to="/">Retour à l'accueil</BackButton>
      </Content>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #1e1e1e;
`;

const Content = styled.div`
  text-align: center;
`;

const Message = styled.div`
  font-size: 18px;
  color: white;
  margin-bottom: 20px;
`;

const BackButton = styled(Link)`
  /* display: inline-block; */
  text-decoration: none;
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 18px;
  font-weight: bold;
  transition: background 0.3s;

  &:hover {
    background-color: #0056b3;
  }
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
  margin: 20px 0;
`;
